export const REGULAR_WORK_DAY_HOURS = 8;

export const MONTH_TYPES = {
  BUSINESS: "Business month",
  REGULAR: "Regular month",
} as const;

export type MonthValue = typeof MONTH_TYPES[keyof typeof MONTH_TYPES];
